import { IWbHttpOptions, WbSessionActions } from '@interco/inter-webview-bridge'

enum CustomActions {
  CHECK_FEATURE = 'checkFeature',
  GET_SUPER_APP_TYPE = 'getSuperAppType',
  SHARE_WEB_VIEW_SCREENSHOT = 'shareWebViewScreenshot',
  DOWNLOAD_TERM = 'downloadTerm',
  NAVIGATE_HOME = 'navigateHome',
  NAVIGATE_TO_HOME = 'navigateToHome',
  RECEIPT_REALIZED_DEEPLINK = 'receiptRealizedDeeplink',
}

export const Actions = {
  ...WbSessionActions,
  ...CustomActions,
}

type CommonArguments = {
  endpoint: string
  headers?: Record<string, string>
  options?: IWbHttpOptions
}

type GetOrDelete = CommonArguments & {
  method: 'GET' | 'DELETE'
}

export type PostOrPut = CommonArguments & {
  method: 'POST' | 'PUT' | 'PATCH'
  body?: Record<string, unknown>
}

export type Request = GetOrDelete | PostOrPut

export type SuperAppType = {
  superAppType: AppType
}

export type CheckFeature = {
  isEnabled: boolean
}
